import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './StringStats.module.css';

const StringStats: React.FC = () => {
  const { t } = useTranslation();
  const [text, setText] = useState('');

  const stats = useMemo(() => {
    const totalChars = text.length;
    const charsWithoutSpaces = text.replace(/\s/g, '').length;
    const chineseChars = (text.match(/[\u4e00-\u9fff]/g) || []).length;
    const englishLetters = (text.match(/[a-zA-Z]/g) || []).length;
    const digits = (text.match(/\d/g) || []).length;
    const punctuation = (text.match(/[^\w\s\u4e00-\u9fff]/g) || []).length;
    const lines = text ? text.split(/\r\n|\r|\n/).length : 0;
    const words = text.trim() ? text.trim().split(/\s+/).length : 0;

    return {
      totalChars,
      charsWithoutSpaces,
      chineseChars,
      englishLetters,
      digits,
      punctuation,
      lines,
      words
    };
  }, [text]);

  const handleClear = () => {
    setText('');
  };

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <h2 className={styles.title}>{t('stringStats.title')}</h2>
        <p className={styles.description}>{t('stringStats.description')}</p>

        <textarea
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder={t('stringStats.placeholder')}
          className={styles.textarea}
        />

        <div className={styles.actionRow}>
          <button onClick={handleClear} className={styles.clearButton}>
            {t('stringStats.clearButton')}
          </button>
        </div>

        <div className={styles.grid}>
          <div className={styles.card}>
            <span className={styles.label}>{t('stringStats.labels.totalChars')}</span>
            <span className={styles.value}>{stats.totalChars}</span>
          </div>
          <div className={styles.card}>
            <span className={styles.label}>{t('stringStats.labels.charsWithoutSpaces')}</span>
            <span className={styles.value}>{stats.charsWithoutSpaces}</span>
          </div>
          <div className={styles.card}>
            <span className={styles.label}>{t('stringStats.labels.chineseChars')}</span>
            <span className={styles.value}>{stats.chineseChars}</span>
          </div>
          <div className={styles.card}>
            <span className={styles.label}>{t('stringStats.labels.englishLetters')}</span>
            <span className={styles.value}>{stats.englishLetters}</span>
          </div>
          <div className={styles.card}>
            <span className={styles.label}>{t('stringStats.labels.digits')}</span>
            <span className={styles.value}>{stats.digits}</span>
          </div>
          <div className={styles.card}>
            <span className={styles.label}>{t('stringStats.labels.punctuation')}</span>
            <span className={styles.value}>{stats.punctuation}</span>
          </div>
          <div className={styles.card}>
            <span className={styles.label}>{t('stringStats.labels.lines')}</span>
            <span className={styles.value}>{stats.lines}</span>
          </div>
          <div className={styles.card}>
            <span className={styles.label}>{t('stringStats.labels.words')}</span>
            <span className={styles.value}>{stats.words}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StringStats;
